'use strict';

var CompetitorDataGridDirective = function CompetitorDataGridDirective() {
  return {
    restrict: 'E',
    template: require('../templates/competitor-data-grid-template.html'),
    replace: true,
    controller: 'CompetitorDataGridController',
    scope: {},
    link: function link(scope) {
      scope.$on('chart:lengthOfStay:selected', function (event, referenceService, originalService, isOneBar, snapshotDate) {
        if (isOneBar) {
          scope.$parent.isCompetitorDataGridVisible = false;
          return;
        }
        scope.retrieveData(referenceService, originalService, snapshotDate);
      });
      scope.$on('chart:services:selectedService', function (evt, originalService) {
        if (!originalService.isUniquePresence && !originalService.carryCount) {
          scope.retrieveData(null, originalService, scope.$parent.snapshotDate);
          scope.$parent.isCompetitorDataGridVisible = true;
        }
      });
    }
  };
};
CompetitorDataGridDirective.$inject = [];
module.exports = CompetitorDataGridDirective;